import type {AriaController} from '@wandb/forge-shell-contract/aria';
import {createContext, useContext} from 'react';

const unavailable = () => ({ok: false, reason: 'unavailable'}) as const;
const noop = () => {};
const unavailableController: AriaController = {
  isAvailable: false,
  startChat: unavailable,
  openChat: noop,
  openChatToThread: noop,
  registerExternalTurn: noop,
  subscribeExternalTurnCreated: () => noop,
  observeThreadAsRead: () => noop,
  markThreadRead: noop,
};

// undefined allows standalone W&B (and older shells) to use its local store.
// null means the shell owns Aria but currently has no registered controller.
export const ShellAriaControllerContext = createContext<
  AriaController | null | undefined
>(undefined);

export function useShellAriaController() {
  const controller = useContext(ShellAriaControllerContext);
  return controller === null ? unavailableController : controller;
}
